// src/firebase/itemsAndInventory/addItem.ts
import { ref, push, set } from "firebase/database";
import { db } from "../firebaseConfig";
import { ItemInfo } from "../../models/item";

export const addItem = async (item: ItemInfo) => {
	try {
		const itemsRef = ref(db, "items"); // Flat structure
		const newItemRef = push(itemsRef);
		await set(newItemRef, item);
		return newItemRef.key;
	} catch (error) {
		console.error("Error saving item:", error);
		throw error;
	}
};
